import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { putRSSLink } from '../../../api/channels';

// TODO: not refactored yet
export const updateRSSLink = createAsyncThunk(
  'channels/updateRSSLink',
  async (rssData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await putRSSLink(rssData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);
